import {Component} from '@angular/core';
@Component({
    standalone: false,
    selector: 'app-mandating-flow-info-card',
    templateUrl: './mandating-flow-info-card.component.html',
    styleUrls: ['./mandating-flow-info-card.component.scss']
})
export class MandatingFlowInfoCardComponent {
}
